import { STANDARD_ROUND } from "./duct-helpers";

export const cfmRoomHeaders = ["Room Type", "CFM / sq ft", "Typical Size (sq ft)", "Typical CFM"];
export const cfmRoomRows: (string | number)[][] = [
  ["Bedroom", 1.0, 150, 150], ["Living Room", 1.0, 300, 300], ["Kitchen", 1.5, 200, 300],
  ["Bathroom", "1 CFM/sq ft or 50 min", 75, 75], ["Dining Room", 1.0, 200, 200],
  ["Home Office", 1.0, 120, 120], ["Basement", 1.0, 600, 600], ["Garage (heated)", 1.5, 400, 600],
  ["Server Room", "2–3", 200, 500], ["Conference Room", 1.5, 300, 450],
];

export const fittingEqHeaders = ["Fitting Type", "Equivalent Length (ft)"];
export const fittingEqRows: (string | number)[][] = [
  ["90° Elbow (R/D=1.5)", 10], ["90° Elbow (Mitered)", 57], ["90° Elbow (3-piece)", 15],
  ["90° Elbow (5-piece)", 12], ["45° Elbow", 5], ["Tee — Branch", 30],
  ["Tee — Straight-through", 0], ["Transition (gradual)", 0], ["Transition (abrupt)", 15],
  ["Round Entry (with screen)", 6], ["Damper (open)", 2], ["Flex Duct (per ft)", 2],
  ["Register Boot", 10], ["Filter Grille", 10],
];

export const maxCfmHeaders = ["Duct Size", "Area (in²)", "Max CFM @600fpm", "Max CFM @900fpm", "Max CFM @1200fpm"];
export const maxCfmRows: (string | number)[][] = STANDARD_ROUND.filter(d => d >= 4 && d <= 36).map(d => {
  const area = Math.PI * (d / 2) ** 2;
  const areaFt = area / 144;
  return [`${d}" ⌀`, Math.round(area), Math.round(areaFt * 600), Math.round(areaFt * 900), Math.round(areaFt * 1200)];
});
